import hyRequest from '@/service'
import { IDataType } from '@/service/types'

// 查询菜单列表
export function listMenu(query) {
  return hyRequest.get<IDataType>({
    url: '/system/menu/list',
    params: query
  })
}

// 查询菜单详细
export function getMenu(menuId) {
  return hyRequest.get<IDataType>({
    url: '/system/menu/' + menuId,
  })
}

// 查询菜单下拉树结构
export function treeselect() {
  return hyRequest.get<IDataType>({
    url: '/system/menu/treeselect',
  })
}

// 根据角色ID查询菜单下拉树结构
export function roleMenuTreeselect(roleId) {
  return hyRequest.get<IDataType>({
    url: '/system/menu/roleMenuTreeselect/' + roleId,
  })
}

// 新增菜单
export function addMenu(data) {
  return hyRequest.post<IDataType>  ({
    url: '/system/menu',
    data: data
  })
}

// 修改菜单
export function updateMenu(data) {
  return hyRequest.put<IDataType>({
    url: '/system/menu',
    data: data
  })
}

// 删除菜单
export function delMenu(menuId) {
  return hyRequest.delete<IDataType>({
    url: '/system/menu/' + menuId,
  })
}